import { getGameRuleApi } from 'api/article'
import errorHandler from 'utils/errorHandler'

export default payload => async (dispatch) => {
  try {
    return await getGameRuleApi(payload)
  } catch (error) {
    return errorHandler(error)
  }
}
